import SchoolProfile from './SchoolProfile.component';

export default SchoolProfile;
